import styled from "styled-components";
import { Box } from "@mui/material";

export const LocationPickerContainer = styled(Box)`
	width: 100%;
	box-sizing: border-box;
	padding: 10px;
	position: relative;
	margin-top: 50px;
	.autocomplete-container {
		position: absolute;
		top: -70px;
		width: 100%;
	}
`;
